import dayjs from 'dayjs'

export default function getProgramEnrollmentExpiration(
  preferredTimezone = 'UTC',
  enrollmentEndDate: string | undefined,
  rollingDeadline = false,
) {
  if (!enrollmentEndDate) {
    return {
      enrollmentEndDate: undefined,
      formattedExpirationDate: '',
      daysRemaining: undefined,
      isExpired: false,
    }
  }

  const tzDate = dayjs.tz(enrollmentEndDate, preferredTimezone).endOf('day')
  const enrollmentEndDateObj = tzDate.toDate()
  const formattedExpirationDate = tzDate.format('MM/DD/YYYY')
  const now = dayjs(new Date())
  const daysRemaining = tzDate.diff(now, 'day')

  const isExpired = dayjs(now).isAfter(tzDate)

  // If rolling deadline is enabled and the program is expired,
  // set the deadline to the next Sunday at 11:59 PM in the preferred timezone
  if (rollingDeadline && isExpired) {
    const nextSunday = dayjs().tz(preferredTimezone).day(7).endOf('day')

    return {
      enrollmentEndDate: nextSunday.toDate(),
      formattedExpirationDate: nextSunday.format('MM/DD/YYYY'),
      daysRemaining: nextSunday.diff(now, 'day'),
      isExpired: false,
    }
  }

  return {
    enrollmentEndDate: enrollmentEndDateObj,
    formattedExpirationDate,
    daysRemaining,
    isExpired,
  }
}
